var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-click-events-modal',{attrs:{"brand":_vm.brand,"product":_vm.productTitle,"url":_vm.url,"clicks":_vm.clickEvents,"loading":_vm.eventsLoading},on:{"closed":_vm.onClosed}})}
var staticRenderFns = []

export { render, staticRenderFns }